const returnToDomainNames = [
    'panasonic.aero',
    'panasonic.com',
    'nextcloud.aero',
    'amazonaws.com',
    'sandbox.my.site.com',
    'localhost',
];

export default returnToDomainNames;
